
// We are using Global Script Tags in index.html for Firebase Compat
// This avoids "firebase.auth is not a function" issues with ESM loaders
// and ensures the global namespace is fully populated.

declare global {
    interface Window {
        firebase: any;
    }
}

const firebase = window.firebase;

if (!firebase) {
    console.error("Firebase Global not found. Ensure script tags are in index.html");
}

import firebaseConfig from './firebase-applet-config.json';

// Initialize if not already initialized
try {
    if (firebase && !firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
    }
} catch (e) {
    console.error("Firebase initialization error:", e);
}

// Access services via the global namespace (Singleton pattern for Compat)
// This is the most robust way to access compat services when loaded via scripts.
// If firebase is undefined or app initialization failed, we export nulls to prevent module evaluation crashes.
const isAppInitialized = firebase && firebase.apps.length > 0;

export const auth = isAppInitialized && firebase.auth ? firebase.auth() : null;
export const db = isAppInitialized && firebase.firestore ? firebase.firestore(firebase.app(), firebaseConfig.firestoreDatabaseId) : null;
export const storage = isAppInitialized && firebase.storage ? firebase.storage() : null;
export const functions = isAppInitialized && firebase.app().functions ? firebase.app().functions('us-central1') : null;

// Access static properties from the namespace safely
export const FieldValue = firebase && firebase.firestore ? firebase.firestore.FieldValue : null;
export const Timestamp = firebase && firebase.firestore ? firebase.firestore.Timestamp : null;

export const increment = firebase && firebase.firestore ? firebase.firestore.FieldValue.increment : null;
export const arrayUnion = firebase && firebase.firestore ? firebase.firestore.FieldValue.arrayUnion : null;
export const arrayRemove = firebase && firebase.firestore ? firebase.firestore.FieldValue.arrayRemove : null;
export const serverTimestamp = firebase && firebase.firestore ? firebase.firestore.FieldValue.serverTimestamp : null;

export default firebase;
